import { useParams } from 'react-router-dom';
import styles from './WebinarContent.module.scss';
import { useEffect, useState } from 'react';
import { BASE_URL } from '../../../../requests/BASE_URL';
import MainContainerLeftControl from '../../../universal_components/MainContainerLeftControl/MainContainerLeftControl';
import WebinarTheses from './WebinarTheses/WebinarTheses';
import WebinarExperts from './WebinarExperts/WebinarExperts';
import WebinarDocs from './WebinarDocs/WebinarDocs';
import WebinarsAside from '../WebinarsAside/WebinarsAside';
import classnames from 'classnames';
import { isMobile } from 'react-device-detect';

const WebinarContent = () => {
  const { id } = useParams();
  const [webinar, setWebinar] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [detailsRes] = await Promise.all([fetch(`${BASE_URL}webinars/${id}`)]);
        const detailsData = await detailsRes.json();

        setWebinar({ ...detailsData });
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) return <p>Загрузка...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className={styles.main}>
      <MainContainerLeftControl widthAside={'300px'} data={<WebinarsAside />}>
        <h1 className={classnames(isMobile ? [styles.sectionTitle, styles.mobile] : [styles.sectionTitle])}>
          {webinar.title}
        </h1>
        <div
          className={classnames(isMobile ? [styles.description, styles.mobile] : [styles.description])}
          dangerouslySetInnerHTML={{ __html: webinar.description }}
        />
        {webinar.theses.length > 0 && <WebinarTheses props={webinar.theses} />}

        {webinar.experts.length > 0 && <WebinarExperts props={webinar.experts} />}

        {webinar.documents.length > 0 && <WebinarDocs props={webinar.documents} />}
      </MainContainerLeftControl>
    </div>
  );
};

export default WebinarContent;
